import { CANAIS_DE_ACESSO, NOME_DO_CANAL, temAlgumCanal, type CanaisDeAcesso, type CanalDeAcesso } from '@orbind/core'
import { Checkbox } from '@orbind/ui'
import './campos-de-canais.css'

/**
 * Os três canais de acesso como checkboxes (SPEC-20261008-1104-canais-de-acesso).
 * Usado no padrão do workspace e na regra própria do colaborador.
 */

const ICONE: Record<CanalDeAcesso, string> = {
  navegador: 'fas fa-globe',
  desktop: 'fas fa-desktop',
  celular: 'fas fa-mobile-alt',
}

const DICA: Record<CanalDeAcesso, string> = {
  navegador: 'Entrar pelo navegador do computador (Chrome, Edge, Safari…).',
  desktop: 'Usar o Orbind instalado na máquina (Windows, macOS, Linux).',
  celular: 'Usar pelo celular ou tablet — no navegador do aparelho ou no aplicativo.',
}

export function CamposDeCanais({
  value,
  onChange,
  disabled = false,
}: {
  value: CanaisDeAcesso
  onChange: (canais: CanaisDeAcesso) => void
  disabled?: boolean
}) {
  return (
    <div className="ccan">
      <div className="ccan__lista">
        {CANAIS_DE_ACESSO.map((canal) => (
          <Checkbox
            key={canal}
            className="ccan__opcao"
            checked={value[canal]}
            disabled={disabled}
            onChange={(e) => onChange({ ...value, [canal]: e.target.checked })}
            label={
              <span className="ccan__texto">
                <strong>
                  <i className={ICONE[canal]} aria-hidden /> {NOME_DO_CANAL[canal]}
                </strong>
                <small>{DICA[canal]}</small>
              </span>
            }
          />
        ))}
      </div>
      {!temAlgumCanal(value) ? (
        <p className="ccan__erro" role="alert">
          <i className="fas fa-exclamation-circle" aria-hidden /> Deixe ao menos um canal liberado.
        </p>
      ) : null}
    </div>
  )
}
